import { render, staticRenderFns } from "./CardInfo.vue?vue&type=template&id=7f7fbcc6&"
import script from "./CardInfo.vue?vue&type=script&lang=js&"
export * from "./CardInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardInfo.vue?vue&type=style&index=0&id=7f7fbcc6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports